import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import 'videojs-contrib-eme';
import 'videojs-markers';
import 'videojs-markers/dist/videojs.markers.css';

import videojscontribads from 'videojs-contrib-ads';
import videojsima from 'videojs-ima';
import 'videojs-ima/dist/videojs.ima.css';

import Simplestream from './simplestream/plugin';
import AdsGooglePause from './ads/google-pause/plugin';
import AdsGoogleVideoStitcher from './ads/google-video-stitcher/plugin';
//import vttThumbnails from './thumbnails/plugin';

import AwsMediaTailor from './ads/aws/plugin'; 
//import Freewheel from './ads/freewheel/plugin'; 
//import GoogleIma from './ads/google/plugin'; 
//import GoogleVideoStitcher from './ads/google-video-stitcher/plugin'; 

window.HELP_IMPROVE_VIDEOJS = false;

export default class player {
    constructor(id, plugins) {

        this.plugins = plugins;

        // Load 3rd-party libraries
        if(this.plugins.includes('youbora')) {
            console.log('Include Youbora');
            this.importer.url('https://smartplugin.youbora.com/v6/js/adapters/videojs/6.7.7/sp.min.js').then(() => {
                youbora.Log.logLevel = youbora.Log.Level.DEBUG;
            }).catch(error => console.error('Could Not Load Youbora'));
        }

        // Get container
        this.container = document.getElementById(id);
        this.container.classList.add('simplestream');

        // Create player container
        const player = document.createElement('div');
        player.classList.add('simplestream-player');
        this.container.appendChild(player);

        // Create <video-js> inside player container
        this.videoElement = document.createElement('video-js');
        this.videoElement.setAttribute('id', 'videojs-' + id); 
        this.videoElement.setAttribute('playsinline', null); 
        this.videoElement.setAttribute('preload', 'auto'); 
        this.videoElement.setAttribute('controls', null); 
        this.videoElement.classList.add('video-js', 'vjs-16-9', 'vjs-big-play-centered', 'vjs-show-big-play-button-on-pause');
        player.appendChild(this.videoElement);

        // Load Google IMA SDK
        this.importer.url('https://imasdk.googleapis.com/js/sdkloader/ima3.js').then(() => {
            //this.importer.url('https://player.simplestream.test/videojs.nuevo.gold/videojs7/plugins/nuevo-dash.js').then(() => {
                //this.importer.url('https://player.simplestream.test/videojs.nuevo.gold/videojs7/nuevo.min.js').then(() => {
                    this.init();
                //}).catch(error => console.error('Could Not Load nuevo.min.js'));
            //}).catch(error => console.error('Could Not Load nuevo-dash.js'));
        }).catch(error => console.error('Could Not Load Google IMA'));

    }

    init() {

        console.log('init()');

        let videoJsOptions = {
            plugins: {
                Simplestream: true,
            },
            /*html5: {
                debug: {
                    logLevel: Debug.LOG_LEVEL_WARNING,
                    dispatchEvent: false
                },
            }*/
        }

        if(this.container.dataset?.setup) {
            videoJsOptions = Object.assign({}, JSON.parse(this.container.dataset.setup), videoJsOptions);
        }

        console.log('videoJS Options:', videoJsOptions);

        this.player = videojs(this.videoElement, videoJsOptions);
        //this.player.nuevoPlugin();

        this.player.on('simplestream-ready', (event, options) => {
            this.ready(options);
            //document.dispatchEvent(new CustomEvent("simplestream-ready", {
            //    "detail": "Simplestream Videojs Plugin Has Loaded"
            //}));
        });

        //window.simplestream.videojs = videojs;
    }

    ready(options) {

        console.log('ready()');

        // Thumbnail Preview
        //if(options.streamsApiResponse.thumbnail_previews) {
        //    this.player.vttThumbnails({
        //        src: options.streamsApiResponse.thumbnail_previews.vtt
        //    });
        //}

        this.initAdsorStream(options);
        //this.continueWatching();
        //this.npaw(options.analyticsApiResponse);
        //this.nielsen(options.analyticsApiResponse);

        //this.events();

    }

    /**
     * If SSAI is enabled, request the SSAI stream from the provider and 
     * override the Streams API response with the SSAI stream.
     */
    initAdsorStream(options) {

        console.log('initAdsorStream()', options.streamsApiResponse);

        // Google Pause Ad
        if(options.streamsApiResponse.ads?.pause?.providerOff == 'google') {
            this.player.Simplestream().tag('Google Pause Ad', 'green');
            console.log('Client Pause Ad - Google');
            this.player.AdsGooglePause();
        }

        // Google Video Stitcher SSAI
        if(options.streamsApiResponse.ads?.ssai?.provider == 'google-video-stitcher') {

            this.player.Simplestream().tag('Google Video Stitcher', 'green');

            // This plugin uses the Streams API Response to request an SSAI stream from Google using the ima_dai.js SDK
            this.player.AdsGoogleVideoStitcher();

            this.player.on('google-video-stitcher-ready', (event, options) => {
                this.setSrc(options.streamsApiResponse);
            });

        // Media Tailor SSAI
        } else if(options.streamsApiResponse.ads?.ssai?.provider == 'media-tailor') {

            this.player.Simplestream().tag('AWS Media Tailor', 'green');

            console.log('SSAI - Media Tailor');
        
            this.setSrc(options.streamsApiResponse);

            this.player.AwsMediaTailor();

        // If we do not have SSAI, init stream
        } else {

            this.setSrc(options.streamsApiResponse);

        }
    
    }

    /**
     * If SSAI is enabled, request the SSAI stream from the provider and 
     * override the Streams API response with the SSAI stream.
     */
    setSrc(streamsApiResponse) {

        console.log('setSrc()', streamsApiResponse);

        // DRM - Widevine
        if(streamsApiResponse.drm 
            && streamsApiResponse.drm.widevine) {

            this.player.Simplestream().tag('DRM');

            this.player.eme();
            
            this.player.src({
                src: streamsApiResponse.drm.widevine.stream,
                type: 'application/dash+xml',
                ads: streamsApiResponse.ads,
                keySystems: {
                    'com.widevine.alpha': {
                        url: streamsApiResponse.drm.widevine.licenseAcquisitionUrl,
                        audioRobustness: 'SW_SECURE_CRYPTO',
                        videoRobustness: 'SW_SECURE_CRYPTO'
                    }
                }
            });

        // DRM - Fairplay
        } else if(streamsApiResponse.drm 
            && streamsApiResponse.drm.fairplay) {

            this.player.Simplestream().tag('DRM');

            this.player.eme();

            this.player.src({
                src: streamsApiResponse.drm.fairplay.stream,
                type: 'application/x-mpegURL',
                ads: streamsApiResponse.ads,
                keySystems: {
                    'com.apple.fps.1_0': {
                        certificateUri: 'https://mm-v2.simplestream.com/spafax/fairplay.cer',
                        //certificateUri: ((location.hostname == 'player.simplestream.test') 
                        //    ? 'https://player.simplestream.test' : 'https://ssmp.simplestreamcdn.com') + '/certificates/fairplay.cer',
                        licenseUri: streamsApiResponse.drm.fairplay.licenseAcquisitionUrl
                    }
                }
            });

        // HLS
        } else {

            this.player.src({
                src: streamsApiResponse.stream,
                type: 'application/vnd.apple.mpegurl',
            });

            /*this.player.on('timeupdate', () => {
                const vhs = this.player.tech().vhs;
                const segments = vhs.playlists.media().segments;
                console.log(segments);
            });*/

            /*var vhs = this.player.tech().vhs;

            this.player.on('timeupdate', () => {
              var currentTime = this.player.currentTime();
              var activePlaylist = vhs.playlists.media();
              var segments = activePlaylist.segments;
              var activeSegment = null;
      
              for (var i = 0; i < segments.length; i++) {
                var segment = segments[i];
                var start = segment.start || 0;
                var end = start + (segment.duration || 0);
                if (currentTime >= start && currentTime < end) {
                  activeSegment = segment;
                  break;
                }
              }
      
              if (activeSegment) {
                console.log('Active Segment:', activeSegment);
                if (activeSegment.programDateTime) {
                    console.log('PROGRAM-DATE-TIME:', activeSegment.programDateTime);
                }
              }
            });*/

        }

        this.setGoogleIma(streamsApiResponse);

        this.setSubtitles(streamsApiResponse);

    }

    setGoogleIma(streamsApiResponse) {

        // Google Ad Tag - Preroll
        if(streamsApiResponse.ads?.csai?.provider == 'google'
            && streamsApiResponse.ads?.csai?.preroll
        ) {

            this.player.Simplestream().tag('Google Preroll', 'green');

            let adTagUrl = streamsApiResponse.ads.csai.preroll;
            //let adTagUrl = 'https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/vmap_ad_samples&sz=640x480&cust_params=sample_ar%3Dpreonly&ciu_szs=300x250%2C728x90&gdfp_req=1&ad_rule=1&output=vmap&unviewed_position_start=1&env=vp&impl=s&correlator=';
            //let adTagUrl = 'https://pubads.g.doubleclick.net/gampad/ads?iu=/3048/d.talktv&description_url=https%3A%2F%2Fwatch.talk.tv%2F&tfcd=0&npa=0&sz=640x480&cust_params=testmode%3Dtest&max_ad_duration=30000&gdfp_req=1&unviewed_position_start=1&output=xml_vmap1&env=vp&impl=s&correlator=&ad_rule=1';

            console.log('Client Preroll - Google IMA', adTagUrl);

            this.player.ima({
                id: this.player.id(),
                adTagUrl: adTagUrl,
                adsManagerLoadedCallback: this.adsManagerLoadedCallback.bind(this),
            });

        // 3rd Party Ad Tag - Preroll
        } else if(streamsApiResponse.ads?.preroll_vast) {

            this.player.Simplestream().tag('VAST Preroll', 'green');

            //this.player.GoogleIma(streamsApiResponse.ads);

        }

    }

    adsManagerLoadedCallback() {
        var events = [
            google.ima.AdEvent.Type.ALL_ADS_COMPLETED,
            google.ima.AdEvent.Type.CLICK,
            google.ima.AdEvent.Type.COMPLETE,
            google.ima.AdEvent.Type.FIRST_QUARTILE,
            google.ima.AdEvent.Type.LOADED,
            google.ima.AdEvent.Type.MIDPOINT,
            google.ima.AdEvent.Type.PAUSED,
            google.ima.AdEvent.Type.RESUMED,
            google.ima.AdEvent.Type.STARTED,
            google.ima.AdEvent.Type.THIRD_QUARTILE
        ];

        for (var index = 0; index < events.length; index++) {
            this.player.ima.addEventListener(events[index], (event) => {
               console.log('Google IMA Event: ' + event.type, event);
               if(event.type == 'allAdsCompleted') {
                   //this.player.ima.endLinearAdMode();
                   this.player.play();
               }
            });
        }

        this.player.on('adslog', (data) => {
            console.log('Google IMA Log:', data);
        });
    }

    setSubtitles(streamsApiResponse) {
        if(streamsApiResponse.tracks 
            && this.player.Simplestream().detectPlatform() == 'chrome') {

            console.log('initSubtitleTracks()');
            this.player.Simplestream().tag('VTT Subtitles');

            this.player.on('loadedmetadata', () => {

                // Get all text tracks for the current player.
                var textTracks = this.player.textTracks().tracks_;
                console.log('Tracks:', textTracks);

                for (var i = 0; i < textTracks.length; i++) {
                    var track = textTracks[i];
                    console.log('Track ' + i + ':');
                    console.log('  kind: ' + track.kind);
                    console.log('  label: ' + track.label);
                    console.log('  language: ' + track.language);
                    console.log('  mode: ' + track.mode);
                }

                var htmlDiv = document.createElement("div");
                htmlDiv.innerHTML = "<style>.vjs-menu-content li:nth-child(3) {display: none;}}</style>";
                document.getElementsByTagName("head")[0].appendChild(htmlDiv);

                // Add .vtt tracks from Streams API
                streamsApiResponse.tracks.forEach((track) => {
                    this.player.addRemoteTextTrack(track, false);
                });

            });

        }
    }

    continueWatching() {
        // Not yet implemented
    }

    npaw(options) {
        if (typeof youbora != "undefined") {
            if(typeof youbora.adapters.Videojs != "undefined") {
                if(this.plugins.includes('youbora')) {
                    console.log('NPAW Player Analytics');
                    window.plugin = new youbora.Plugin({
                        'accountCode': 'simplestream',
                    });
                    plugin.setOptions(options);
                    plugin.setAdapter(new youbora.adapters.Videojs(this.player));
                } else {
                    console.log('NPAW Page Analytics');
                    npawPlugin.registerAdapterFromClass(this.player, NpawPluginAdapters.video.Videojs);
                }
            } else {
                console.error('Youbora Adapter Not Loaded');
            }
        } else {
            console.error('Youbora Adapter Not Loaded');
        }
    }

    nielsen(options) {
        if (typeof nSdkInstance != "undefined") {

            let playTime = 0;
            let lastUpdateTime = 0;
            let content_metadata_object = options.nielsen_analytics;

            this.player.on('loadedmetadata', function(event) {
                nSdkInstance.ggPM('loadMetadata', content_metadata_object);
            });

            this.player.on('timeupdate', function(event) {
                const currentTime = Math.floor(this.currentTime());

                if (currentTime !== lastUpdateTime) {
                    playTime = currentTime;
                    lastUpdateTime = currentTime;
                    nSdkInstance.ggPM('setPlayheadPosition', playTime);
                }
            });

            this.player.on('pause', function(event) {
                playTime = Math.floor(this.currentTime());
                nSdkInstance.ggPM('stop', playTime);
            });

            this.player.on('ended', function(event) {
                playTime = Math.floor(this.currentTime());
                nSdkInstance.ggPM('end', playTime);
            });

        } else {
            console.error('Neilsen Adapter Not Loaded');
        }
    }

    events() {

        const EVENTS = [

            // HTMLMediaElement events
            'abort',
            'canplay',
            'canplaythrough',
            'durationchange',
            'emptied',
            'ended',
            'error',
            'loadeddata',
            'loadedmetadata',
            'loadstart',
            'pause',
            'play',
            'playing',
            'progress',
            'ratechange',
            'seeked',
            'seeking',
            'stalled',
            'suspend',
            'timeupdate',
            'volumechange',
            'waiting',
        
            // HTMLVideoElement events
            'enterpictureinpicture',
            'leavepictureinpicture',
        
            // Element events
            'fullscreenchange',
            'resize',
        
            // video.js events
            'audioonlymodechange',
            'audiopostermodechange',
            'controlsdisabled',
            'controlsenabled',
            'debugon',
            'debugoff',
            'disablepictureinpicturechanged',
            'dispose',
            'enterFullWindow',
            'error',
            'exitFullWindow',
            'firstplay',
            'fullscreenerror',
            'languagechange',
            'loadedmetadata',
            'loadstart',
            'playerreset',
            'playerresize',
            'posterchange',
            'ready',
            'textdata',
            'useractive',
            'userinactive',
            'usingcustomcontrols',
            'usingnativecontrols',
        ];

        EVENTS.forEach((event) => {
            this.player.on(event, function(event) {
                videojs.log(event);
            });
        });

    }

    errorScreen(msg) {

        videojs(video).dispose();

        const errorScreen = document.createElement('div');
        errorScreen.classList.add('error');
	    errorScreen.innerHTML = '<p>' +
            '<img src="data:image/svg+xml;utf8;base64,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" />' +
        '</p>' +
        '<p>Error</p>' +
        '<p>' + msg + '</p>';

        this.ssmp.getElementsByClassName('player')[0].appendChild(errorScreen);

    }

    dispose() {
        this.player.dispose();
    }

    importer = {
        url: (url) => {
            return new Promise((resolve, reject) => {
                let script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = url;
                script.addEventListener('load', () => resolve(script), false);
                script.addEventListener('error', () => reject(script), false);
                document.body.appendChild(script);
            });
        },
        urls: (urls) => {
            return Promise.all(urls.map(importer.url));
        }
    };
}